import { Box, List } from "@material-ui/core"
import { FooterSocialLinks } from "common/SiteLinks"
import AiIcon from "components/Icons/RedesignIcons/AiIcon"
import BusinessIcon from "components/Icons/RedesignIcons/BusinessIcon"
import GiftCardIcon from "components/Icons/RedesignIcons/GiftCardIcon"
import GroupCardIcon from "components/Icons/RedesignIcons/GroupCardIcon"
import LogoConffetiIcon from "components/Icons/RedesignIcons/LogoConffetiIcon"
import LogoForNavigationIcon from "components/Icons/RedesignIcons/LogoForNavigationIcon"
import NextLink from "components/Reusable/Bit/NextLink"
import styled from "styled-components"
import FooterSocialLinksList from "./FooterSocialLinksList"

const StyledBurgerNavigationWrapper = styled.div<{ $isOpen: boolean }>`
  height: ${(p) => (p.$isOpen ? " 110vh" : " 100vh")};
  width: 100vw;
  background-color: #ffffff;
  padding: ${(p) => (p.$isOpen ? "0" : "78px 0 0")};
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: flex-end;
  transform: ${(p) => (p.$isOpen ? "translateY(-10vh)" : "translateY(-100%)")};
  transition: 0.5s transform cubic-bezier(0.73, 0.32, 0.34, 1.5),
    0.5s height cubic-bezier(0.73, 0.32, 0.34, 1.5),
    0.5s padding cubic-bezier(0.73, 0.32, 0.34, 1.5);

  ${(p) => p.theme.breakpoints.up("md")} {
    justify-content: center;
  }
  overflow: auto;
`

const StyledContentWrapper = styled.nav<{ $isOpen: boolean }>`
  padding: 32px 16px 16px;
  height: calc(100% - 10vh);
  color: #000000;

  ${(p) => p.theme.breakpoints.up("md")} {
    display: ${(p) => (p.$isOpen ? "flex" : "none")};
    flex-direction: column;
    justify-content: flex-end;

    @media screen and (max-height: 610px) {
      padding: 52px 16px 16px;
      justify-content: flex-start;
    }
  }
`

const StyledUl = styled(List)`
  margin-top: 10vh;
  list-style: none;
  padding: 0;
  text-align: right;
  position: relative;
  z-index: 9;

  ${(p) => p.theme.breakpoints.up("md")} {
    display: flex;
    justify-content: center;
    gap: 64px;
    margin: 60px auto 120px;
  }
`

const StyledUlSecondary = styled(List)`
  list-style: none;
  padding: 0;
  text-align: right;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 9;

  ${(p) => p.theme.breakpoints.up("md")} {
    justify-content: center;
    flex-direction: row;
    gap: 16px;
  }
`

const StyledNavButton = styled(Box).attrs({ component: "a" })`
  padding: 16px 0;
  display: flex;
  gap: 16px;
  align-items: center;
  &:first-child {
    padding-top: 0;
  }

  ${(p) => p.theme.breakpoints.up("md")} {
    flex-direction: column;
    justify-content: space-between;
    padding: 0;
    svg {
      width: 104px;
      height: 104px;
    }
  }

  &:hover {
    h3 {
      border-bottom: 2px solid var(--Yellow, #ffbc0d);
    }
  }
`

const StyledNavSecondaryButton = styled(Box).attrs({ component: "a" })`
  padding: 8px 0;
  align-items: center;
  font-size: 18px;
  font-weight: 400;
  line-height: 19.8px;
  letter-spacing: 0.015em;
  text-align: right;
  margin: 0;
  ${(p) => p.theme.breakpoints.down("sm")} {
    &:first-child {
      padding-top: 16px;
    }
    &:last-child {
      margin-bottom: 16px;
    }
  }
  ${(p) => p.theme.breakpoints.up("md")} {
    padding: 3px 4px 11px;
  }
`

const StyledText = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 22px;
  display: flex;
  align-items: center;
  text-align: right;
  letter-spacing: 0.015em;
  color: #000000;
  margin: 0;
  font-family: Speedee, NarkisBlock-Thin;

  ${(p) => p.theme.breakpoints.up("md")} {
    font-size: 24px;
    font-weight: 400;
    line-height: 26.4px;
    letter-spacing: 0.015em;
    padding-bottom: 8px;
    margin-top: 5px;
    text-align: right;
    min-height: 36px;
    align-items: flex-start;
  }
`

const StyledSocialIconsList = styled(List)<{ $isOpen: boolean }>`
  display: flex;
  gap: 16px;
  padding: 0;
  margin: 0 auto;
  position: relative;
  z-index: 9;

  ${(p) => p.theme.breakpoints.up("md")} {
    margin: 24px auto 154px;
    gap: 19.2px;
  }
  opacity: ${(p) => (p.$isOpen ? "1" : "0")};

  transition: 0.5s opacity cubic-bezier(0.5, 0.55, 0.04, 1.8);
`

const StyledLogoWrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: flex-end;

  ${(p) => p.theme.breakpoints.up("md")} {
    svg {
      width: 255px;
      height: 280px;
    }
  }
`

const BurgerNavigation = ({ isOpen }: { isOpen: boolean }) => {
  const navigation = [
    {
      icon: <LogoConffetiIcon />,
      label: "שליחת גיפטקארד",
      url: "/quick-purchase ",
    },
    {
      icon: <GroupCardIcon />,
      label: "מתנה משותפת",
      url: "/groupPurchases",
    },
    {
      icon: <AiIcon />,
      label: "ברכה ב-AI",
      url: "/create-ai",
    },
    {
      icon: <BusinessIcon />,
      label: "גיפטקארד לעסקים",
      url: "/companies",
    },
    {
      icon: <GiftCardIcon />,
      label: "בירור יתרה",
      url: "/balance",
    },
  ]
  const additionalNavigation = [
    {
      label: "נגישות",
      url: "/accessibility",
    },
    {
      label: "יצירת קשר",
      url: "https://api.whatsapp.com/send?phone=972545738031",
    },
    {
      label: "מקדונלד'ס ישראל",
      url: "https://www.mcdonalds.co.il/",
    },
  ]
  return (
    <StyledBurgerNavigationWrapper $isOpen={isOpen}>
      <StyledContentWrapper $isOpen={isOpen}>
        <StyledUl>
          {navigation?.map((nav, i) => {
            return (
              <NextLink href={nav.url} key={i} passHref aria-label={nav.label}>
                <StyledNavButton>
                  {nav.icon}
                  <StyledText>{nav.label}</StyledText>
                </StyledNavButton>
              </NextLink>
            )
          })}
        </StyledUl>
        <StyledUlSecondary>
          {additionalNavigation.map((nav, i) => {
            return (
              <NextLink href={nav.url} key={i} passHref>
                <StyledNavSecondaryButton>{nav.label}</StyledNavSecondaryButton>
              </NextLink>
            )
          })}
        </StyledUlSecondary>
        <StyledSocialIconsList $isOpen={isOpen}>
          {/* <WhatsAppIcon />
          <InstagramIcon />
          <TikTokIcon />
          <FacebookIcon />
          <TwitterIcon />
          <YoutubeIcon /> */}
          <FooterSocialLinksList linkList={FooterSocialLinks.links} />
        </StyledSocialIconsList>
      </StyledContentWrapper>
      <StyledLogoWrapper>
        <LogoForNavigationIcon />
      </StyledLogoWrapper>
    </StyledBurgerNavigationWrapper>
  )
}

export default BurgerNavigation
